import React, { ReactNode } from 'react';
import { createPortal } from 'react-dom';

export default function CheckoutSummaryAfter({
  children,
}: {
  children: ReactNode;
}): JSX.Element {
  const checkoutSidebarAfterEl = document.getElementById(
    'checkout-sidebar-after'
  );

  if (!checkoutSidebarAfterEl) {
    return <></>;
  }

  return createPortal(children, checkoutSidebarAfterEl);
}
